import {CommonService} from '../../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {MergingDialogComponent} from './merging-dialog/merging-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-merging-sale-points',
  styleUrls: ['./merging-sale-points.component.scss'],
  templateUrl: './merging-sale-points.component.html'
})
export class MergingSalePointsComponent implements OnInit {
  newSalePoints: MatTableDataSource<any> = new MatTableDataSource<any>();
  originalNewSalePoints: [];
  districtSalePoints: MatTableDataSource<any> = new MatTableDataSource<any>();
  originalDistrictSalePoints: [];
  isLoadingNew = false;
  isLoadingDistrict = false;
  isLoading = true;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('paginator1', {static: true}) paginator1: MatPaginator;
  columnDictionary = [
    {key: 'key1', value: 'Key1'},
    {key: 'id', value: 'Yummy ID'},
    {key: 'customer_code', value: 'Κωδικός Πελάτη'},
    {key: 'customer_name', value: 'Επωνυμία'},
    {key: 'vat_number', value: 'Α.Φ.Μ'},
    {key: 'address', value: 'Διεύθυνση'},
    {key: 'postal_code', value: 'Ταχ. Κώδικας'},
    {key: 'division_id', value: 'Division ID'},
    {key: 'division_name', value: 'Division'},
    {key: 'sales_group_id', value: 'Κωδ. Δρομολογίου'},
    {key: 'sales_group_name', value: 'Δρομολόγιο'},
    {key: 'actions', value: 'Ενέργειες'}];
  displayColumns = ['key1', 'id', 'customer_code', 'customer_name', 'vat_number', 'address', 'postal_code', 'division_id', 'division_name', 'sales_group_id', 'sales_group_name', 'actions'];
  selectedColumns1 = this.columnDictionary;
  selectedColumns2 = this.columnDictionary;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
  }

  public async ngOnInit(): Promise<any> {

    await this.initNewSalePoints();
    await this.initDistrictSalePoints();

    this.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.paginator1 = this.commonService.setPaginatorTexts(this.paginator1);
    this.isLoading = false;

  }

  equals(objOne, objTwo) {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne.key === objTwo.key;
    }
  }

  getSelectedColumns1() {
    return this.selectedColumns1.map(c => c.key);
  }

  getSelectedColumns2() {
    return this.selectedColumns2.map(c => c.key);
  }

  setSelectedColumns1() {

  }

  async initNewSalePoints() {
    try {
      this.isLoadingNew = true;
      this.originalNewSalePoints = await this.commonService.getSimpleList(`sale_point/merge_new`) as [];
      this.newSalePoints = new MatTableDataSource<any>(this.originalNewSalePoints);
      this.newSalePoints.paginator = this.paginator;
      this.newSalePoints.sort = this.sort;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoadingNew = false;
    }
  }

  async initDistrictSalePoints() {
    try {
      this.isLoadingDistrict = true;
      this.originalDistrictSalePoints = await this.commonService.getSimpleList(`sale_point/merge_district`) as [];
      this.districtSalePoints = new MatTableDataSource<any>(this.originalDistrictSalePoints);
      this.districtSalePoints.paginator = this.paginator1;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoadingDistrict = false;
    }
  }

  showMergeDialog(group: number, salePoint: any) {
    // const similarSalePoints = group === 1 ?
    //   this.originalNewSalePoints.filter((sp: any) => sp.vat_number === salePoint.vat_number
    //     && sp.sales_group_id === salePoint.sales_group_id && sp.division_id === salePoint.division_id) :
    //   this.originalDistrictSalePoints.filter((sp: any) => sp.vat_number === salePoint.vat_number
    //     && sp.sales_group_id === salePoint.sales_group_id && sp.division_id === salePoint.division_id);
    const similarSalePoints = group === 1 ?
      this.originalNewSalePoints.filter((sp: any) => sp.vat_number === salePoint.vat_number) :
      this.originalDistrictSalePoints.filter((sp: any) => sp.vat_number === salePoint.vat_number);

    const dialog = this.matDialog.open(MergingDialogComponent, {
      disableClose: true,
      data: {
        salePoints: similarSalePoints
      }
    });

    dialog.afterClosed().subscribe(async (hasChanges) => {
      if (hasChanges) {
        if (group === 1) {
          await this.initNewSalePoints();
        } else {
          await this.initDistrictSalePoints();
        }
      }
    });
  }

  applyNewFilter(value: any) {
    this.newSalePoints.filter = value.trim().toLowerCase();
  }

  applyDistrictFilter(value: any) {
    this.districtSalePoints.filter = value.trim().toLowerCase();
  }

  setSelectedColumns2() {

  }

  public setTableHeight(): number {
    return window.innerHeight - 403;
  }

}
